import { Link, Navigate, Route, Routes } from 'react-router-dom';
import HomePage from '../../modules/dashboard/pages/HomePage';
import MedicinesPage from '../../modules/medicines/pages/MedicinesPage';
import CreateOrderPage from '../../modules/orders/pages/CreateOrderPage';
import OrdersListPage from '../../modules/orders/pages/OrdersListPage';
import UsersPage from '../../modules/users/pages/UsersPage';
import { User } from '../../types/auth';

type PrivateLayoutProps = {
  user: User;
  onLogout: () => void;
};

export default function PrivateLayout({ user, onLogout }: PrivateLayoutProps) {
  return (
    <div className="app-shell">
      <aside className="sidebar card">
        <h2>Boticlick</h2>
        <p className="subtitle">Sesion: {user.email}</p>
        <nav className="menu">
          <Link to="/admin">Inicio</Link>
          <Link to="/admin/medicinas">Medicinas</Link>
          <Link to="/admin/ordenes">Ordenes</Link>
          <Link to="/admin/usuarios">Usuarios</Link>
        </nav>
        <button className="ghost-button" onClick={onLogout} type="button">
          Cerrar sesion
        </button>
      </aside>

      <main className="main-content">
        <Routes>
          <Route path="/admin" element={<HomePage user={user} />} />
          <Route path="/admin/medicinas" element={<MedicinesPage />} />
          <Route path="/admin/ordenes" element={<OrdersListPage />} />
          <Route path="/admin/ordenes/nuevo" element={<CreateOrderPage />} />
          <Route path="/admin/usuarios" element={<UsersPage />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </main>
    </div>
  );
}
